import React from "react";
import { injectIntl } from "react-intl";
import { Tab, Tabs } from "react-bootstrap";
import StatsGeneral from "./general/StatsGeneral";
import StatsModal from "./StatsModal";
import StatsPharma from "./pharma/StatsPharma";

class Stats extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
    };
  }

  dowloadFile(fileName, response) {
    let dataReceived = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(dataReceived);
    link.download = `${fileName}.xlsx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onClickExport(fileName, onExport) {
    this.setState({
      modal: <StatsModal confirm={true} close={() => this.closeModal()} />,
    });

    const successCallback = (response) => {
      this.setState({ modal: null });
      this.dowloadFile(fileName, response);
    };

    onExport(successCallback);
  }

  closeModal() {
    this.setState({ modal: null });
  }

  openConfModal(fileName, onExport) {
    this.setState({
      modal: (
        <StatsModal
          confirm={false}
          successCallback={() => this.onClickExport(fileName, onExport)}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  render() {
    return (
      <>
        <Tabs defaultActiveKey="stats-general" id="statsTabs" mountOnEnter>
          <Tab
            eventKey="stats-general"
            title={this.props.intl.formatMessage({ id: "General.Indicators" })}
          >
            <StatsGeneral
              openConfModal={(fileName, onExport) =>
                this.openConfModal(fileName, onExport)
              }
            />
          </Tab>

          <Tab eventKey="stats-pharma" title={"PHARMA"}>
            <StatsPharma
              openConfModal={(fileName, onExport) =>
                this.openConfModal(fileName, onExport)
              }
            />
          </Tab>
        </Tabs>
        {this.state.modal}
      </>
    );
  }
}

export default injectIntl(Stats);
